import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navs',
  templateUrl: './tournament-layout.component.html',
  styleUrls: ['./tournament-layout.component.scss']
  
})
export class TournamentLayoutComponent implements OnInit {
  public isLoading: boolean = false;
  public panes = [
    { name: 'Info', content: 'info' },
    { name: 'Matches', content: 'matches' },

  ];
  activeTab: string = 'info'; 

  constructor(
    public router: Router,
    public route: ActivatedRoute,
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.determineActiveTab(event.urlAfterRedirects);
    });
  }
  determineActiveTab(url: string) {
    this.activeTab = this.panes.find(pane => url.includes(pane.content))?.content || 'info';
  }

  ngOnInit(): void {
    // Initialize active tab based on the initial route
    this.determineActiveTab(this.router.url);
  }
  



navigateTo(tab: string) {
    this.activeTab = tab;
    // Use Angular router to navigate to the corresponding page
    // this.router.navigate([tab]);
    this.router.navigate([tab], { relativeTo: this.route});

  }



}
